import { render, staticRenderFns } from "./ElFileUploadTable.vue?vue&type=template&id=5febb6d1&scoped=true&"
import script from "./ElFileUploadTable.vue?vue&type=script&lang=js&"
export * from "./ElFileUploadTable.vue?vue&type=script&lang=js&"
import style0 from "./ElFileUploadTable.vue?vue&type=style&index=0&id=5febb6d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5febb6d1",
  null
  
)

export default component.exports